var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.7,266.3c30.5,43.5,68,76.4,105.7,92.7c29.8,12.9,46.2,17,61.2,17c5,0,9.9-0.5,15-1.2 c12.4-1.8,38.9-15.4,44.8-31.9c5-13.9,5.8-27.9,3.5-32.4c-1.9-4-5.8-5.8-11.1-8.2c-0.8-0.4-1.6-0.7-2.4-1.1 c-5.3-2.7-36.2-18-42.5-20.2c-4.7-1.8-12.4-4.7-18.6,4.7c-3.9,5.8-15.2,19.2-19.3,23.8c-1.8,2.1-3.2,3.3-8.5,0.6 c-35.5-17.7-58.7-31.4-82.2-71.7c-1.9-3.4-1.8-3.7,3.1-8.8c3.8-4,9.6-10.1,15.2-21.1c3-5.9,1.1-11.1-0.6-14.4 c-1-2-7.4-17.6-12.6-30.1c-2.4-6-4.7-11.5-6.3-15.3c-4.9-12.1-11-13-16.2-13c-0.4,0-0.8,0-1.2,0c-3.8-0.2-7.8-0.2-12-0.2 c-3.4,0-11.9,0.9-19.4,9c-0.4,0.4-0.8,0.9-1.2,1.3c-6.4,6.9-21.3,22.9-21.3,52.8c0,29.6,19.8,58.1,25.9,66.2 C179.8,264.9,180.2,265.5,180.7,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.4,76C413.2,28.6,350.2,2.5,283.2,2.5C145,2.5,32.7,114.9,32.7,253c0,43.5,11.3,86.3,32.6,123.8 L28.8,509.6L164.7,474c36.1,19.4,77,29.7,118.4,29.7c66.9,0,130.2-26.1,178.2-73.5c48.2-47.5,74.7-110.4,74.7-177 C536,187.9,509.1,125,460.4,76z M118.8,369.3L113,360C93,328.2,82.3,291.2,82.3,253.1c0-110.7,90.2-200.8,201-200.8 c53.7,0,104.1,20.9,142,58.9c39.5,39.6,61.2,90.1,61.1,142.2c0,53.3-21.4,103.7-60.1,141.9c-38.6,38-89.5,59-143.1,59 c-36,0-71.4-9.7-102.3-28l-8.9-5.3l-72.4,19.1L118.8,369.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ae93f926adcfa0214602e04fc65d7c7c.svg";
export { ForwardRef as ReactComponent };